// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { SocialAuthProviders } from '@config';

export interface AccountLinkingResult {
  provider: SocialAuthProviders;
  socialAccountId: string;
  linked: boolean;
}
